module.exports = __webpack_public_path__ + "img/auth-discord.ecc6de0a.svg";